import { render, staticRenderFns } from "./BookingAskSignature.vue?vue&type=template&id=1bec5ab8&"
import script from "./BookingAskSignature.vue?vue&type=script&lang=ts&"
export * from "./BookingAskSignature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports